// @flow
import { useState } from 'react';

function useLocalStorage(key: string) {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = localStorage.getItem(key);

      if (item) {
        return JSON.parse(item);
      }

      return null;
    } catch (e) {
      // Could not get the item from LocalStorage
      return null;
    }
  });

  const setValue = (value: any) => {
    try {
      const valueToStore = value;

      setStoredValue(valueToStore);
      localStorage.setItem(key, JSON.stringify(valueToStore));

      return valueToStore;
    } catch (error) {
      // Could not set value in LocalStorage
      return null;
    }
  };

  return [storedValue, setValue];
}

export default useLocalStorage;
